import { useQuery } from 'react-query'

import { IFilter } from 'src/components/filter/types/filter.types'
import { removeDefaultParams } from 'src/common/utils'
import { QUERY_KEYS } from 'src/constants'
import StepService from 'src/services/steps.service'

const initialImpactsFilterValues = {
  query: '',
}

export const useStepImpacts = (stepId: string, filter: IFilter = {}) => {
  return useQuery(
    [QUERY_KEYS.STEP_IMPACTS, stepId, filter ?? ''],
    () =>
      StepService.getStepImpacts(stepId, removeDefaultParams(filter, initialImpactsFilterValues)),
    {
      keepPreviousData: true,
      enabled: !!stepId,
    },
  )
}
